// deployment_class: customer_env_allowed
/**
 * useHasScope — the boolean capability primitive for the Settings & Account IA
 * (spec 2026-06-24 §4.1). Returns whether the authenticated actor's computed
 * scope set (from `/v3/auth/me` → `computeScopes`) includes `scope`.
 *
 * This is the canonical read for conditioning UI on CAPABILITY rather than role
 * name — the Settings section registry (§4.2) and any future module use it to
 * show/hide controls. It pairs with the shipped <RequireScope> route-gate
 * component:
 *   - useHasScope(scope)  → boolean — show/hide a control or settings section
 *   - <RequireScope>      → render-gate for a whole route (PortalNotAccessible)
 * Both consume the same `useAuth().scopes`, so there is exactly one source of
 * truth. Unauthenticated sessions carry an empty scope set, so this fails
 * CLOSED (returns false) by construction — never trust the client gate alone;
 * it sits ON TOP of the backend default-deny (spec §9, wall layer 6).
 */
import { useAuth } from './useAuth';

export function useHasScope(scope: string): boolean {
  const { scopes } = useAuth();
  return scopes.includes(scope);
}
